const HeroProduct = () => {
  const heroProductArticle = document.querySelector(".hero-product__article");
  const heroProductContent = document.querySelector(".hero-product__content");
  const heroProducttoggleBtn = document.querySelector(".hero-product__content-toggle-btn");

  if (!heroProductContent || !heroProducttoggleBtn) return;

  const desktopMaxHeight = 346;
  const tabletMaxHeight = 264;
  const mobileMaxHeight = 280;

  const getMaxHeight = () => {
    if (window.innerWidth >= 1024) return desktopMaxHeight;
    if (window.innerWidth >= 768 && window.innerWidth <= 1023) return tabletMaxHeight;
    if (window.innerWidth >= 375 && window.innerWidth <= 767) return mobileMaxHeight;
    return mobileMaxHeight;
  };

  const isBtnNeed = heroProductContent.scrollHeight >= getMaxHeight();

  heroProducttoggleBtn.classList.toggle("d-none", !isBtnNeed);

  const toggleContent = () => {
    heroProductContent.classList.toggle("opened");
    heroProductArticle.classList.toggle("opened");
    heroProducttoggleBtn.textContent = heroProductContent.classList.contains("opened") ? "hide" : "open all";
  };

  heroProducttoggleBtn.addEventListener("click", toggleContent);
};

export default HeroProduct;
